import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_3606_2642)">
            <path
                d="M5.11811 12.2038C3.0689 11.648 1.16516 10.4474 1.16516 7.8599C1.16516 5.39968 2.54903 4.01581 5.00925 4.01581L5.05699 4.01598C5.59598 2.17419 7.09571 1.16528 9.38015 1.16528C12.1644 1.16528 13.7831 2.66401 13.9172 5.34275C15.7858 5.37535 16.8348 6.45341 16.8348 8.34738C16.8348 10.7886 15.0151 11.8559 13.0794 12.3215"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.60632 14.2993C7.46666 15.3494 7.99127 15.8741 8.99969 16.6927C10.0081 15.8741 10.5327 15.3494 11.3931 14.2993"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.99988 10.3059V16.6798"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.97192 4.01782C6.39138 4.01782 7.66085 4.95342 8.0613 5.8082"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3606_2642">
                <rect width="18" height="18" fill="white" />
            </clipPath>
        </defs>
    </svg>,
) as React.FC<{ className?: string }>;
